export default "__VITE_ASSET__pSeE5zl0__"